import Promise from 'bluebird';
import cognitesdk from '@cognite/cognitesdk';

let privateSubdomain = [];
let granularity = '1h';

export const getSubdomain = () => privateSubdomain;

export const getGranularity = () => granularity;

export const cogniteloader = (tags = []) => {
  let firstSeries = undefined;
  const calculateGranularity = (domain, pps) => {
    const diff = domain[1] - domain[0];
    for (let i = 1; i <= 60; i += 1) {
      const points = diff / (1000 * i);
      if (points < pps) {
        return `${i === 1 ? '' : i}s`;
      }
    }
    for (let i = 1; i <= 60; i += 1) {
      const points = diff / (1000 * 60 * i);
      if (points < pps) {
        return `${i === 1 ? '' : i}m`;
      }
    }
    for (let i = 1; i < 24; i += 1) {
      const points = diff / (1000 * 60 * 60 * i);
      if (points < pps) {
        return `${i === 1 ? '' : i}h`;
      }
    }
    for (let i = 1; i < 100; i += 1) {
      const points = diff / (1000 * 60 * 60 * 24 * i);
      if (points < pps) {
        return `${i === 1 ? '' : i}day`;
      }
    }
    return 'day';
  };
  return (domain, subDomain, config, oldSeries, reason) => {
    privateSubdomain = subDomain;
    if (tags.length === 0) {
      return {};
    }
    if (reason === 'INTERVAL') {
      return oldSeries;
    }
    return Promise.map(tags, ({ step, value }) => {
      const nPoints = config.pointsPerSerie || 1000;
      granularity = calculateGranularity(subDomain, nPoints);
      if (subDomain[1] - subDomain[0] < 100) {
        // Zoomed REALLY far in
        return oldSeries;
      }
      return cognitesdk
        .getDatapoints({
          tagId: value,
          granularity,
          aggregates: `${step ? 'step' : 'avg'},count`,
          start: subDomain[0],
          end: subDomain[1],
          limit: nPoints,
        })
        .then(({ items }) => {
          const points = items[0].datapoints;
          if (points.reduce((p, c) => p + (c.count || 0), 0) < nPoints / 5) {
            // Can use raw dataseries instead of any aggregates
            return cognitesdk
              .getDatapoints({
                tagId: value,
                start: subDomain[0],
                end: subDomain[1],
                limit: nPoints,
              })
              .then(({ items: i }) => {
                let datapoints = i[0].datapoints.map(d => ({
                  [`${step ? 'stepInterpolation' : 'average'}`]: d.value,
                  timestamp: d.timestamp,
                }));
                if (step) {
                  if (points.length > 0) {
                    datapoints = [points[0], ...datapoints];
                  }
                  datapoints = [
                    ...datapoints,
                    {
                      timestamp: subDomain[1],
                      stepInterpolation:
                        datapoints[datapoints.length - 1].stepInterpolation,
                    },
                  ];
                }
                return {
                  id: i[0].tagId,
                  data: datapoints,
                  step: step || false,
                  raw: true,
                };
              });
          }
          return {
            id: items[0].tagId,
            data: items[0].datapoints,
            step: step || false,
          };
        })
        .catch(err => {
          console.log(err);
          return null;
        });
    }).then(results => {
      const series = {};
      results.forEach(d => {
        if (!d) {
          // Either it failed to load, or 403 error
          return;
        }
        const oldSerie = oldSeries[d.id];
        if (oldSerie && d.data.length > 0) {
          const xAccessor = oldSerie.xAccessor || config.xAxis.accessor;
          const oldData = ((firstSeries && firstSeries[d.id]) || oldSerie).data;
          const firstPoint = xAccessor(d.data[0]);
          const lastPoint = xAccessor(d.data[d.data.length - 1]);
          let insertionStart = 0;
          let insertionEnd = d.data.length - 1;

          for (let idx = 1; idx < oldData.length; idx += 1) {
            if (xAccessor(oldData[idx]) >= firstPoint) {
              insertionStart = idx;
              break;
            }
          }
          for (let idx = oldData.length - 1; idx > 0; idx -= 1) {
            if (xAccessor(oldData[idx]) <= lastPoint) {
              insertionEnd = idx + 1;
              break;
            }
          }
          d.data =
            firstPoint === lastPoint
              ? [
                  ...oldData.slice(0, insertionStart),
                  ...d.data,
                  ...oldData.slice(insertionEnd),
                ]
              : [
                  ...oldData.slice(0, insertionStart),
                  ...d.data,
                  ...oldData.slice(insertionEnd),
                ];
        } else if (d.data.length === 0) {
          d.data = (oldSerie || { data: [] }).data;
        }
        series[d.id] = {
          data: d.data,
          step: d.step,
          drawPoints: d.raw,
          yAccessor: d.step
            ? data => data.stepInterpolation || 0
            : data => data.average,
        };
      });
      if (reason === 'MOUNTED') {
        firstSeries = series;
      }
      return series;
    });
  };
};



// WEBPACK FOOTER //
// ./src/utils/cogniteloader.js